var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('vmc-header'),_c('page-heading',{attrs:{"page-title-name":"ABOUT VERITAS","image-link":"blue_background.jpg"}}),_c('router-view'),_c('vmc-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }